import React from 'react'
import Dialog from 'material-ui/Dialog'
import { AddPersonModal, CreateList, CsvImport, DeleteListModal } from './Modals'

const modalType = Modal => {
  const ModalType = props => (
    <Dialog
      contentStyle={{
        width: 442
      }}
      open={props.open}
    >
      {props.purpose === 'addPerson' ? (
        <AddPersonModal
          contactId={props.contactId}
          addPerson={props.addPerson}
          handleClose={props.handleClose}
          snackbarOpen={props.snackbarOpen}
        />
      ) : props.purpose === 'editPerson' ? (
        <AddPersonModal
          contactId={props.contactId}
          editPerson={props.editPerson}
          handleClose={props.handleClose}
          snackbarOpen={props.snackbarOpen}
          user={props.user}
        />
      ) : props.purpose === 'create-list' ? (
        <CreateList
          location={props.location}
          createContactList={props.createContactList}
          handleClose={props.handleClose}
        />
      ) : props.purpose === 'editName' ? (
        <CreateList
          location={props.location}
          updateContactList={props.updateContactList}
          contactId={props.contactId}
          name={props.name}
          handleClose={props.handleClose}
        />
      ) : props.purpose === 'deleteList' ? (
        <DeleteListModal
          location={props.location}
          deleteContactList={props.deleteContactList}
          contactId={props.contactId}
          handleClose={props.handleClose}
        />
      ) : props.purpose === 'csvImport' ? (
        <CsvImport
          fetchListDetails={props.fetchListDetails}
          csvUpload={props.csvUpload}
          handleClose={props.handleClose}
          contactId={props.contactId}
        />
      ) : (
        ''
      )}
    </Dialog>
  )
  return ModalType
}

export default modalType



// WEBPACK FOOTER //
// ./src/routes/Contacts/ListName/ModalHOC.js